<template>
    <p class="mb-0" v-if="showSingleValueOnly">
        Tax free cash: <span class="d-inline-block text-end font-monospace text-nowrap cash-value fs-5">{{ formatter.formatCurrency(standard) }}</span>
    </p>
    <template v-else>
        <p class="mb-0">
            Standard: <span class="d-inline-block text-end font-monospace text-nowrap cash-value fs-5">{{ formatter.formatCurrency(standard) }}</span>
            <template v-if="showPIE || showBP">, </template>
            <template v-if="showPIE">
                {{ pieText }}:
                <span class="d-inline-block text-end font-monospace text-nowrap cash-value fs-5">{{ formatter.formatCurrency(pieValue) }}</span>
            </template>
            <template v-if="showBP">
                {{ bpoText }}:
                <span class="d-inline-block text-end font-monospace text-nowrap cash-value fs-5">{{ formatter.formatCurrency(bpValue) }}</span>
            </template>
        </p>
    </template>
</template>

<script setup lang="ts">
import { ref, computed, watch, PropType } from "vue";
import TaxFreeCashModelSupporter from "@/guiide/ts/assets/finalsalary/taxFreeCashModelSupporter";
import FinalSalaryOption from "@/guiide/ts/assets/finalsalary/finalSalaryOption";
import { formatter } from "@/shared/ts/formatter";
import { useFinalSalaryStaticOptions } from "@/guiide/ts/assets/finalsalary/useFinalSalaryOptionInfoStatic";

const props = defineProps({
    model: { type: TaxFreeCashModelSupporter, required: true },
    selectedOption: { type: Number as PropType<FinalSalaryOption>, required: true }
});

const standard = ref<number>(props.model.getActual(FinalSalaryOption.SchemeDefault));
const pieValue = ref<number>(props.model.getActual(FinalSalaryOption.PensionIncreaseExchange));
const bpValue = ref<number>(props.model.getActual(FinalSalaryOption.BridgingPension));

const { finalSalaryOptionsStatic } = useFinalSalaryStaticOptions();
const pieText = ref(finalSalaryOptionsStatic.value.pensionIncreaseExchange.abbreviation);
const bpoText = ref(finalSalaryOptionsStatic.value.bridgingPension.abbreviation);

watch(
    () => props.model.selected,
    () => {
        standard.value = props.model.getActual(FinalSalaryOption.SchemeDefault);
        pieValue.value = props.model.getActual(FinalSalaryOption.PensionIncreaseExchange);
        bpValue.value = props.model.getActual(FinalSalaryOption.BridgingPension);
    }
);

const showSingleValueOnly = computed<boolean>(() => !props.model.optionsHaveDifferentMax);

const showPIE = computed<boolean>(() => props.selectedOption == FinalSalaryOption.PensionIncreaseExchange);
const showBP = computed<boolean>(() => props.selectedOption == FinalSalaryOption.BridgingPension);

</script>

<style scoped>
.cash-value {
    min-width: 8ch;
}
</style>